import { render, staticRenderFns } from "./DeleteLb.vue?vue&type=template&id=62bffad4&"
import script from "./DeleteLb.vue?vue&type=script&lang=js&"
export * from "./DeleteLb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports